import { Redirect, useParams } from 'react-router-dom';
import { useState } from 'react';
import { ChatList, ChatThread } from 'components/modules';
import { useFetchInboundMessagesMeta, useDeviceDetect, useAuth } from 'hooks';
import { routes } from 'const';

function Messages() {
  const { id } = useParams();
  const { isTablet } = useDeviceDetect();
  const { lastUpdatedThreadId } = useFetchInboundMessagesMeta();
  const [isMobileMessageSelected, setMobileMessageSelected] = useState(false);
  const { id: userId } = useAuth();

  const hasChatList = !isMobileMessageSelected || !isTablet;
  const hasChatThread = !isTablet || isMobileMessageSelected;

  const toggleChatThread = () => isTablet && setMobileMessageSelected(!isMobileMessageSelected);

  return !id && lastUpdatedThreadId && !isTablet ? (
    <Redirect
      to={{
        pathname: `${routes.messages}/${lastUpdatedThreadId}`,
      }}
    />
  ) : (
    <>
      {hasChatList && <ChatList selectedConversationId={id} onSelectMessage={toggleChatThread} />}
      {hasChatThread && <ChatThread selectedConversationId={id} onClickBack={toggleChatThread} accountId={userId} />}
    </>
  );
}

export default Messages;
